import { motion, useInView, useAnimation } from "framer-motion";
import data from "../data.json";
import { useRef, useEffect } from "react";
import { SocialIcon } from "react-social-icons";


const SingleProject = ({ project }) => {
    return (
        <motion.div className="single-project" whileHover={{ scale: 1.1 }}>
            <h2 style={{ marginLeft: "1rem", marginBottom: "1rem" }}><span style={{ textDecoration: "none", color: "white" }} >{project.title}</span> <SocialIcon url={project.github} target="_blank" network={"github"} style={{ height: "2.5rem", width: "2.5rem", borderRadius: "2.5rem" }} /></h2>
            <p style={{ paddingLeft: "1rem", paddingRight: "1rem", fontSize: "15px" }}>{project.description}</p>
            <div style={{ display: "flex", flexWrap: "wrap", marginTop: "1rem" }}>
                {project.techStack.map((tech) => {
                    return <span style={{ marginLeft: "1rem", marginBottom: "0.5rem", paddingLeft: "4px", paddingRight: "4px", backgroundColor: "#1e96fc", borderRadius: "5px", fontSize: "15px", height: "25px" }}>{tech}</span>
                })}
            </div>
        </motion.div>
    )
}

const Projects = ({ refProjects }) => {
    const ref = useRef(null);
    const isInView = useInView(ref)
    const mainControlls = useAnimation();
    useEffect(() => {
        if (isInView) {
            mainControlls.start("visible")
        }
        else {
            mainControlls.start("hidden")
        }

    }, [isInView,mainControlls])
    return (
        <div className="item" ref={refProjects}>
            <div ref={ref}>

                <motion.div className="projects-motion" variants={{
                    hidden: { opacity: 0, x: 100 },
                    visible: { opacity: 1, x: 0 }
                }}
                    initial="hidden"
                    animate={mainControlls}
                    transition={{ duration: 0.5, delay: 0.1 }}
                    whileHover={{ scale: 1 }}>
                    <div className="item-title">Projects</div>
                    <div className="projects-item">

                        {data.projects.map((project) => {
                            return <SingleProject project={project} />
                        })}
                    </div>
                </motion.div>
            </div>
        </div>
    )
}

export default Projects;